module.exports = __webpack_public_path__ + "public/images/full-class.214ebc5a9692919a3dbfabac1a1ce888.png";